// Module
var code = "<div class=\"ups-menu-list\">\r\n    <div class=\"row\">\r\n        <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\">\r\n            <div class=\"ups-group ups-group_condensed\">\r\n                <ng-content select=\"[item-header]\"></ng-content>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>";
// Exports
module.exports = code;